import { getErrorDisplayMarkup } from "@components/error-boundary/error-boundary-utils";
import { ErrorWithTitle } from "@components/error-boundary/error-types";
import { SanitizedHtmlTag } from "@components/sanitized-html-tag";
import { useToast } from "@flat-ui";

interface Props {
  /** The error to be show in toast */
  error: ErrorWithTitle;

  /** Handler to close the toast */
  onClose(): void;
}

/** Displays an error message in a Toast on the bottom left of the screen. */
export function ErrorToast({ error, onClose }: Props): React.JSX.Element {
  const { openToast } = useToast();

  openToast({
    title: error.title,
    message: <SanitizedHtmlTag markup={getErrorDisplayMarkup(error.error)} />,
    variant: "error",
    onClose,
  });

  // eslint-disable-next-line react/jsx-no-useless-fragment -- Should return <> to satisfy React.JSX.Element return type
  return <></>;
}
